const config = {
  defaultItemsPerPage: 20,
  defaultPerPageOptions: [10, 20, 50],
  defaultPageNo: 1,
  colWidth: 145,
  colMinWidth: 100,
  typeCreateDMData: 1,
  typeEditDMData: 2,
  typeCloneDMdata: 3,
};

const EMPLOYEE_TABLE_FIELDS = [
  { id: "empId", label: "Employee ID", accessorKey: "empId", filerType: "multi-select", isDefaultPinned: true, isDraggable: false, isKey: true, isReq: true },
  {
    id: "empName",
    label: "Employee name",
    accessorKey: "empName",
    viewType: "profile",
    filerType: "multi-select",
    isDefaultPinned: true,
    isDraggable: false,
    isReq: true,
  },
  { id: "empEml", label: "Email", accessorKey: "empEml", type: "text", filerType: "multi-select", isKey: true, isReq: true },
  { id: "status", label: "Employment status", accessorKey: "status", viewType: "lookup", filerType: "multi-select", isReq: true },
  { id: "empTyp", label: "Employment type", accessorKey: "empTyp", viewType: "lookup", filerType: "multi-select", isReq: true },
  { id: "depart", label: "Department", accessorKey: "depart", viewType: "lookup", filerType: "multi-select", isReq: true },
  { id: "designation", label: "Designation", accessorKey: "designation", viewType: "lookup", filerType: "multi-select", isReq: true },
  { id: "empPhone", label: "Phone", accessorKey: "empPhone", viewType: "phone", filerType: "multi-select", isReq: true, isKey: true },
  { id: "strtDt", label: "Date of joining", accessorKey: "strtDt", viewType: "date", filerType: "date", isReq: true },
  { id: "reportingMngr", label: "Reporting manager", accessorKey: "reportingMngr", viewType: "profile", filerType: "multi-select", isReq: true },
  { id: "userTyp", label: "User type", accessorKey: "userTyp", viewType: "lookup", filerType: "multi-select", isReq: true },
  { id: "address", label: "Address", accessorKey: "address", viewType: "address", type: "address", hideOnFilter: true },
  { id: "panNo", label: "PAN number", accessorKey: "panNo", type: "text", filerType: "multi-select" },
  { id: "aadharNo", label: "Aadhar number", accessorKey: "aadharNo", type: "text", filerType: "multi-select" },
  { id: "fb", label: "Facebook", accessorKey: "facebook", viewType: "link" },
  { id: "li", label: "LinkedIn", accessorKey: "linkedin", viewType: "link" },
  { id: "ig", label: "Instagram", accessorKey: "instagram", viewType: "link" },
  { id: "tw", label: "X", accessorKey: "twitter", viewType: "link" },
  { id: "createdBy", label: "Created by", accessorKey: "createdBy", viewType: "profile", type: "profile", filerType: "multi-select", hideFromImport: true },
  { id: "updatedTs", label: "Last updated on", accessorKey: "updatedTs", viewType: "date-time", filerType: "date-time", hideFromImport: true },
];
const EMPLOYEE_TABLE_HIDDEN_FIELDS = [
  { id: "ctc", label: "CTC", accessorKey: "ctc", filerType: "multi-select", isDefaultPinned: true, isDraggable: false, isReq: true },
];

export const TABLE = { config, EMPLOYEE_TABLE_FIELDS, EMPLOYEE_TABLE_HIDDEN_FIELDS };
